<template>
	<div>
		<div class="left-box" :style="{'left': right2}" @click="showQrCode">微信扫一扫</div>
		<div class="right-box" :style="{'left': right1}">
			<div class="tip">微信扫码学习</div>
			<img src="../../assets/images/zzchCode.jpg" alt="image" />
			<div class="tip">随时随地，学习专业课</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			// 是否显示二维码
			isShow: false,
			right1: "0px",
			right2: "-150px"
		};
	},
	methods: {
		showQrCode() {
			if (!this.isShow) {
				this.right1 = "0px";
				this.right2 = "150px";
			} else {
				this.right1 = "-150px";
				this.right2 = "0px";
			}
			this.isShow = !this.isShow;
		}
	}
};
</script>

<style scoped>
.left-box {
    transition: all 0.5s;
	position: fixed;
	right: 150px;
	bottom: 335px;
	display: flex;
	align-items: center;
	margin-right: 3px;
	width: 20px;
	height: 80px;
	text-align: center;
	background: #409eff;
	color: aliceblue;
	line-height: 1.1;
	z-index: 9999;
	font-size: 12px;
	cursor: pointer;
	box-shadow: 0px 1px 2px rgb(12, 59, 107);
}
.right-box {
    transition: all 0.5s;
	display: flex;
	justify-content: center;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
	position: fixed;
	right: 0;
	bottom: 300px;
	width: 150px;
	height: 170px;
	z-index: 9999;
	background: #409eff;
}
.right-box {
	border-radius: 2px;
	box-shadow: 0px 1px 2px rgb(12, 59, 107);
}
.right-box img {
	width: 100%;
	width: 120px;
	height: 120px;
}
.tip {
	text-align: center;
	width: 100%;
	font-size: 14px;
	color: aliceblue;
}
</style>